import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const partitionAsync = async (source, predicate) => {
    const dataFunc = nextIterationAsync(source, async (value) => {
        const passed = await predicate(value);
        return [passed, value];
    });
    const values = await typeDataToArray(dataFunc);
    const fail = [];
    const pass = [];
    for (const [passed, value] of values) {
        if (passed) {
            pass.push(value);
        }
        else {
            fail.push(value);
        }
    }
    return [pass, fail];
};
